/** Price per email sent: one value for the API and the app (contracts). */
export { GTM_PRICE_PER_EMAIL_USD } from '@laplace/contracts'

/**
 * Emails one person gets: the first email and up to two follow-ups. The
 * sequence stops when they reply, so a person may get two.
 */
export const GTM_EMAILS_PER_PERSON = { min: 2, max: 3 } as const
